<template>
    <div class="overview-total">
        <div class="row">
            <div class="col-md-12">
                <div class="overview-total-bonus">
                    <span class="alt">{{ bonusText }} {{ monthName }}</span>
                    <span>Incl. werkgeverslasten</span>
                </div>
            </div>
            <div class="col-md-12 text-md-right">
                <div class="overview-total-amount">
                    <span>&euro; {{ formatCurrency(bonus) }}</span>
                    <button
                        v-if="editable"
                        class="btn btn-primary"
                        @click="saveMonthBonus"
                    >
                        Opslaan
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import RockCurrencyMixin from '@/mixins/RockCurrencyMixin.js';

export default {
    mixins: [RockCurrencyMixin],
    props: ['bonus', 'editable', 'monthName'],
    computed: {
        bonusText: function () {
            if (this.editable) {
                return 'Verwachte bonus';
            }
            return 'Bonus';
        }
    },
    methods: {
        saveMonthBonus: function () {
            this.$emit('save');
        }
    }
};
</script>
